<ion-content>
  <ion-label>
    {{ 'm/task-process/delete-message' | translate }}
  </ion-label>
</ion-content>
<div class="footer">
  <ion-button (click)="ok()">
    {{ 'm/ok' | translate }}
  </ion-button>
  <ion-button (click)="cancel()" fill="outline">
    {{ 'm/cancel' | translate }}
  </ion-button>
</div>
